import { TableProps } from 'antd';
import { ViewTab } from '../../ViewTab.enum';

const MaterialColumns: TableProps['columns'] = [
  {
    title: 'NO.',
    dataIndex: 'no',
    sorter: true,
  },
  {
    title: 'ACTIVITY / RESOURCE CODE',
    dataIndex: 'activityResCode',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'ACTIVITY / RESOURCE DESCRIPTION',
    dataIndex: 'activityResName',
    sorter: false,
    ellipsis: true,
  },
  {
    title: 'PLANT / LEDGER CODE',
    dataIndex: 'plantLedgerCode',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'PLANT / LEDGER DESCRIPTION',
    dataIndex: 'plantLedgerName',
    sorter: false,
    ellipsis: true,
  },
  {
    title: 'MATERIAL CODE',
    dataIndex: 'materialCode',
    sorter: true,
  },
  {
    title: 'MATERIAL DESCRIPTION',
    dataIndex: 'materialDesc',
    sorter: false,
    ellipsis: true,
  },
  {
    title: 'UNIT',
    dataIndex: 'unit',
    sorter: true,
  },
  {
    title: 'QTY',
    dataIndex: 'requiredQuantity',
    sorter: true,
  },
  {
    title: 'REMARKS',
    dataIndex: 'remarks',
    sorter: true,
  },
];

const DocumentColumns: TableProps['columns'] = [
  {
    title: 'DOCUMENT NAME',
    dataIndex: 'docName',
    sorter: true,
  },
  {
    title: 'TYPE',
    dataIndex: 'docType',
    sorter: true,
  },
  {
    title: 'STATUS',
    dataIndex: 'docStatus',
    sorter: true,
  },
  {
    title: 'FORMAT',
    dataIndex: 'docFormat',
    sorter: true,
  },
  {
    title: 'DESCRIPTION',
    dataIndex: 'description',
    sorter: true,
  },
];

export const MapColumns = {
  [ViewTab.DETAILS]: null,
  [ViewTab.MATERIALS]: MaterialColumns,
  [ViewTab.DOCUMENTS]: DocumentColumns,
};
